var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal fade show",
        attrs: {
          id:
            "apparatus-with-multiple-subscriptions" + _vm.apparatus.apparatusId,
          role: "dialog"
        }
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("span", { attrs: { tabindex: "0" } }),
          _c(
            "div",
            { staticClass: "modal-content", attrs: { tabindex: "-1" } },
            [
              _c("header", { staticClass: "modal-header" }, [
                _c(
                  "div",
                  { staticClass: "row w-100 no-gutters align-items-center" },
                  [
                    _c("div", { staticClass: "col" }, [
                      _c("h2", { staticClass: "modal-title" }, [
                        _c("i", {
                          staticClass:
                            "far fa-exclamation-triangle colorOrange mr-1"
                        }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("xYourAccountNeedsAttentionHeader")) +
                            " "
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "float-right col-auto" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-icon-button--gray btn-icon-button",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.closeApparatusWithMultipleSubscriptionsModal()
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-times" })]
                      )
                    ])
                  ]
                )
              ]),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("xApparatusHasMultipleSubsBodyText", {
                            0: _vm.getApparatusTypeAsString,
                            1: _vm.apparatus.preferredDealerName,
                            2: _vm.currentPremiumSubscription.product?.name,
                            3: _vm
                              .$moment(
                                _vm.currentPremiumSubscription.renewalDate
                              )
                              .format(_vm.$t("xShortDate"))
                          })
                        ) +
                        " "
                    )
                  ])
                ])
              ]),
              _c("ModalFooter", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.goToCancelModal()
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xCancelPlanLowercase")) + " ")]
                )
              ])
            ],
            1
          )
        ])
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade show",
        attrs: {
          id:
            "home-premium-apparatus-with-multiple-subscriptions" +
            _vm.apparatus.apparatusId,
          role: "dialog"
        }
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("span", { attrs: { tabindex: "0" } }),
          _c(
            "div",
            { staticClass: "modal-content", attrs: { tabindex: "-1" } },
            [
              _c("header", { staticClass: "modal-header" }, [
                _c(
                  "div",
                  { staticClass: "row w-100 no-gutters align-items-center" },
                  [
                    _c("div", { staticClass: "col" }, [
                      _c("h2", { staticClass: "modal-title" }, [
                        _c("i", {
                          staticClass:
                            "far fa-exclamation-triangle colorOrange mr-1"
                        }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("xYourAccountNeedsAttentionHeader")) +
                            " "
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "float-right col-auto" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-icon-button--gray btn-icon-button",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.closeHomePremiumApparatusWithMultipleSubscriptionsModal()
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-times" })]
                      )
                    ])
                  ]
                )
              ]),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("xAlreadyManagedPleaseRemoveApparatus", {
                            0: _vm.apparatus.name,
                            1: _vm.apparatus.preferredDealerName,
                            2: _vm.getApparatusTypeAsString,
                            3: _vm.currentPremiumSubscription.product?.name
                          })
                        ) +
                        " "
                    )
                  ])
                ])
              ]),
              _c("ModalFooter", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "button",
                      disabled: _vm.billingMaintenanceFeatureFlagEnabled(
                        _vm.currentAppConfig
                      )
                    },
                    on: {
                      click: function($event) {
                        return _vm.goToRemoveModal()
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xRemoveFromPlan")) + " ")]
                )
              ])
            ],
            1
          )
        ])
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade show",
        attrs: {
          id:
            "apparatus-with-multiple-subscriptions-mobile-platform" +
            _vm.apparatus.apparatusId,
          role: "dialog"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered modal-lg",
            staticStyle: { width: "560px" }
          },
          [
            _c("span", { attrs: { tabindex: "0" } }),
            _c(
              "div",
              { staticClass: "modal-content", attrs: { tabindex: "-1" } },
              [
                _c("header", { staticClass: "modal-header" }, [
                  _c(
                    "div",
                    { staticClass: "row w-100 no-gutters align-items-center" },
                    [
                      _c("div", { staticClass: "col" }, [
                        _c("h2", { staticClass: "modal-title" }, [
                          _c("i", {
                            staticClass:
                              "fa fa-exclamation-circle colorOrange mr-1"
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("xYourAccountNeedsAttentionHeader")
                              ) +
                              " "
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "float-right col-auto" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-icon-button--gray btn-icon-button",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.closeApparatusWithMultipleSubscriptionsMobilePlatformModal()
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-times" })]
                        )
                      ])
                    ]
                  )
                ]),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "mb-3" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "xApparatusHasMultipleSubsOnMobileBodyText1",
                                {
                                  0: _vm.apparatus.name,
                                  1: _vm.apparatus.preferredDealerName,
                                  2: _vm.currentPremiumSubscription.product
                                    ?.name,
                                  3: _vm
                                    .$moment(
                                      _vm.currentPremiumSubscription.renewalDate
                                    )
                                    .format(_vm.$t("xShortDate"))
                                }
                              )
                            ) +
                            " "
                        )
                      ]),
                      _vm.currentPremiumSubscription.store ===
                      _vm.subscriptionStoreTypesApple
                        ? _c("div", [
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "xApparatusHasMultipleSubsOnAppleBodyText2"
                                    )
                                  ) +
                                  " "
                              )
                            ]),
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    "https://account.apple.com/account/manage/section/subscriptions."
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm.currentPremiumSubscription.store ===
                      _vm.subscriptionStoreTypesGoogle
                        ? _c("div", [
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "xApparatusHasMultipleSubsOnAndroidBodyText2"
                                    )
                                  ) +
                                  " "
                              )
                            ]),
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    "https://play.google.com/store/account/subscriptions."
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  ])
                ]),
                _c("ModalFooter", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary flex flex-grow-1",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.closeApparatusWithMultipleSubscriptionsMobilePlatformModal()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xDone")) + " ")]
                  )
                ])
              ],
              1
            )
          ]
        )
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade show",
        attrs: {
          id:
            "remove-apparatus-with-multiple-subscriptions-mobile-platform" +
            _vm.apparatus.apparatusId,
          role: "dialog"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered modal-lg",
            staticStyle: { width: "560px" }
          },
          [
            _c("span", { attrs: { tabindex: "0" } }),
            _c(
              "div",
              { staticClass: "modal-content", attrs: { tabindex: "-1" } },
              [
                _c("header", { staticClass: "modal-header" }, [
                  _c(
                    "div",
                    { staticClass: "row w-100 no-gutters align-items-center" },
                    [
                      _c("div", { staticClass: "col" }, [
                        _c("h2", { staticClass: "modal-title" }, [
                          _c("i", {
                            staticClass:
                              "fa fa-exclamation-circle colorOrange mr-1"
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("xYourAccountNeedsAttentionHeader")
                              ) +
                              " "
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "float-right col-auto" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-icon-button--gray btn-icon-button",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.closeRemoveApparatusWithMultipleSubscriptionsMobilePlatformModal()
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-times" })]
                        )
                      ])
                    ]
                  )
                ]),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "mb-3" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "xRemoveApparatusHasMultipleSubsOnMobileBodyText1",
                                {
                                  0: _vm.apparatus.name,
                                  1: _vm.apparatus.preferredDealerName,
                                  2: _vm.getApparatusTypeAsString,
                                  3: _vm.currentPremiumSubscription.product
                                    ?.name
                                }
                              )
                            ) +
                            " "
                        )
                      ]),
                      _vm.currentPremiumSubscription.store ===
                      _vm.subscriptionStoreTypesApple
                        ? _c("div", [
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "xRemoveApparatusHasMultipleSubsOnAppleBodyText2"
                                    )
                                  ) +
                                  " "
                              )
                            ]),
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    "https://account.apple.com/account/manage/section/subscriptions."
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm.currentPremiumSubscription.store ===
                      _vm.subscriptionStoreTypesGoogle
                        ? _c("div", [
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "xRemoveApparatusHasMultipleSubsOnAndroidBodyText2"
                                    )
                                  ) +
                                  " "
                              )
                            ]),
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    "https://play.google.com/store/account/subscriptions."
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  ])
                ]),
                _c("ModalFooter", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary flex flex-grow-1",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.closeRemoveApparatusWithMultipleSubscriptionsMobilePlatformModal()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xDone")) + " ")]
                  )
                ])
              ],
              1
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }